


































import Vue from 'vue';
import { mapGetters } from "vuex";
import OctBrokerConnectionTimeline from "@/components/Depot/OctBrokerConnectionTimeline.vue";
import OctOwnerData from "@/components/Depot/OctOwnerData.vue";
import OctPlacedOrderList from "@/components/Depot/OctPlacedOrderList.vue";
import { DEPOT_LOADED, DEPOT_STORE } from "@/common/store/modules/DepotStore";

export default Vue.extend({
  name: 'OctUserProfile',
  components: {
    OctBrokerConnectionTimeline,
    OctOwnerData,
    OctPlacedOrderList
  },
  computed: {
    ...mapGetters(DEPOT_STORE, [DEPOT_LOADED]),
  },
});
